import { QueryResult } from 'react-query';
import { useApi, Controller, callApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { Termin } from './termin';
// eslint-disable-next-line import/no-cycle
import { Ansprechpartner } from './ansprechpartner';
// eslint-disable-next-line import/no-cycle
import { Angebot } from './angebot';
import { AngebotPosition } from './angebotPosition';
// eslint-disable-next-line import/no-cycle
import { Auftrag } from './auftrag';
// eslint-disable-next-line import/no-cycle
import { AuftragPosition } from './auftragPosition';
// eslint-disable-next-line import/no-cycle
import { Rechnung } from './rechnung';
// eslint-disable-next-line import/no-cycle
import { RechnungPosition } from './rechnungPosition';
// eslint-disable-next-line import/no-cycle
import { LieferungPosition } from './lieferungPosition';
// eslint-disable-next-line import/no-cycle
import { Lieferung } from './lieferung';
import { Attachment } from './attachment';
import { Maschinenkunde } from './maschinenkunde';
// eslint-disable-next-line import/no-cycle
import { Zusatzadresse } from './zusatzadresse';
// eslint-disable-next-line import/no-cycle
import { Service } from './service';
import { ServicePosition } from './servicePosition';

export interface Kunde {
    nr: number;
    anrede: string;
    name1: string;
    name2: string;
    strasse: string;
    postfach: string;
    plz: string;
    ort: string;
    land: string;
    telefon: string;
    fax: string;
    mail: string;
    www: string;
    suchfeld: string;
    art: string;
    konzernNr: number;
    konzernName1: string;
    betreuer: number;
    telBetreuer: number;

    uid: string;
    konto: string;
    blz: string;
    bank: string;
    iban: string;
    bic: string;
    bhDebKonto: string;
    debBh: number;
    bhKredKonto: string;
    kredBh: number;
    fbnr: string;
    zahlZiel: number;
    zahlZielK: number;

    kategorie: string;
    anzMa: number;
    archiv: boolean;
    eiglKnr: string;
    ara: number;
    eva: boolean;
    reclayProduktgruppe: string;
    kreditlimit: number;
    bemerkung: string;
    liefBem: string;
    autoLief: boolean;

    umsatzLfd: number;
    umsatzVj1: number;
    umsatzVj2: number;
    umsatzVj3: number;

    bMargeLfd: number;
    bMargeVj1: number;
    bMargeVj2: number;
    bMargeVj3: number;

    latitude: number | null;
    longitude: number | null;

    mahnstufe0: number | null;
    mahnstufe1: number | null;
    mahnstufe2: number | null;
    mahnstufe3: number | null;

    anlageDat?: string;
    anlageUhr?: number;
    anlageUser?: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;

    taskBetreuerNrList?: number[];
    ansprechpartnerList?: Ansprechpartner[];
    zusatzadresseList?: Zusatzadresse[];
    maschinenkundeList?: Maschinenkunde[];
    angebotList?: Angebot[];
    angebotPositionList?: AngebotPosition[];
    serviceList?: Service[];
    servicePositionList?: ServicePosition[];
    auftragList?: Auftrag[];
    auftragPositionList?: AuftragPosition[];
    lieferungList?: Lieferung[];
    lieferungPositionList?: LieferungPosition[];
    rechnungList?: Rechnung[];
    rechnungPositionList?: RechnungPosition[];
    terminList?: Termin[];
    attachmentList?: Attachment[];
    brancheList?: number[];
    // produktgruppeList?: number[];
    interesseFuerProdukteList?: number[];
    erweiterteSucheList?: number[];
}

export interface KundeFilter {
    nr?: number | null;
    nrOrDebNrOrKredNr?: number | null;
    nrList?: number[];
    searchText?: string;
    searchTextFromBeginning?: boolean;
    searchTextMultiPart?: boolean;
    betreuer?: number;
    plzVon?: string;
    plzBis?: string;
    umsatzVon?: number | null;
    umsatzBis?: number | null;
    maschine?: string;
    mtNr?: number | null;
    branchen?: number[];
    // produktgruppen?: number[];
    interesseFuerProdukte?: number[];
    includeArchiv?: boolean;
    maxRows?: number;
    withTaskBetreuerNrList?: boolean;
    withAnsprechpartnerList?: boolean;
    withZusatzadresseList?: boolean;
    withMaschinenkundeList?: boolean;
    withAngebotList?: boolean;
    withServiceList?: boolean;
    withAngebotPositionList?: boolean;
    withAuftragList?: boolean;
    withAuftragPositionList?: boolean;
    withLieferungList?: boolean;
    withLieferungPositionList?: boolean;
    withRechnungList?: boolean;
    withRechnungPositionList?: boolean;
    withTerminList?: boolean;
    withBrancheList?: boolean;
    withProduktgruppeList?: boolean;
    withErweiterteSucheList?: boolean;
    withInteresseFuerProdukteList?: boolean;
    withAttachmentList?: boolean;
    withMahnstufen?: boolean;
    updateGeoPoints?: boolean;
}

export const defaultKunde: Kunde = {
    nr: -1,
    anrede: 'FI',
    name1: '',
    name2: '',
    strasse: '',
    postfach: '',
    plz: '',
    ort: '',
    land: 'AT',
    telefon: '',
    fax: '',
    mail: '',
    www: '',
    suchfeld: '',
    art: '',
    konzernNr: 0,
    konzernName1: '',
    betreuer: 0,
    telBetreuer: 0,

    uid: '',
    konto: '',
    blz: '',
    bank: '',
    iban: '',
    bic: '',
    bhDebKonto: '',
    debBh: 0,
    bhKredKonto: '',
    kredBh: 0,
    fbnr: '',
    zahlZiel: 0,
    zahlZielK: 0,

    kategorie: '',
    anzMa: 0,
    archiv: false,
    eiglKnr: '',
    ara: 0,
    eva: false,
    reclayProduktgruppe: '',
    kreditlimit: 3000,
    bemerkung: '',
    liefBem: '',
    autoLief: false,

    latitude: null,
    longitude: null,

    mahnstufe0: null,
    mahnstufe1: null,
    mahnstufe2: null,
    mahnstufe3: null,

    umsatzLfd: 0,
    umsatzVj1: 0,
    umsatzVj2: 0,
    umsatzVj3: 0,

    bMargeLfd: 0,
    bMargeVj1: 0,
    bMargeVj2: 0,
    bMargeVj3: 0,
};

export async function getKunde(filter: KundeFilter): Promise<Kunde[]> {
    return callApi<Kunde[]>(Controller.kunde + '/list', {
        filter,
    });
}

export function useKunde(filter: KundeFilter, apiOptions?: UseApiOptions<Kunde>): QueryResult<Kunde> {
    return useApi<Kunde>(Controller.kunde + '/one', { filter }, apiOptions);
}

export function useKundeList(filter: KundeFilter, apiOptions?: UseApiOptions<Kunde[]>): QueryResult<Kunde[]> {
    return useApi<Kunde[]>(Controller.kunde + '/list', { filter }, apiOptions);
}

export interface KundeBranche {
    kNr: number;
    bNr: number;
}

export function useKundeBrancheList(
    kNrList: number[],
    apiOptions?: UseApiOptions<KundeBranche[]>,
): QueryResult<KundeBranche[]> {
    return useApi<KundeBranche[]>(Controller.kunde + '/kundebranchelist', { kNrList }, apiOptions);
}

interface AddKundeResult {
    newNr: number;
}

export async function addKunde(kunde: Kunde): Promise<AddKundeResult> {
    return callApi<AddKundeResult>(Controller.kunde + '/add', { kunde });
}

export async function updateKunde(kunde: Kunde): Promise<void> {
    return callApi<void>(Controller.kunde + '/update', { kunde });
}

export async function assignKundeBetreuer(kunde: Kunde): Promise<void> {
    return callApi<void>(Controller.kunde + '/assignbetreuer', { kunde });
}

export async function assignKundeTelBetreuer(kunde: Kunde): Promise<void> {
    return callApi<void>(Controller.kunde + '/assigntelbetreuer', { kunde });
}

export function getMwstCode(kunde: Kunde): number {
    return kunde?.land === 'AT' ? 20 : 0;
}
